<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClicktab">
      <el-tab-pane label="卷板账单" name="first" v-if="btnFlg[0]">
        <juan-ban-z-d ref="jbBill" v-if="activeName=='first'"></juan-ban-z-d>
      </el-tab-pane>
      <el-tab-pane label="建材账单" name="second"  v-if="btnFlg[1]">
        <jian-cai-z-d ref="jcBill" v-if="activeName=='second'"></jian-cai-z-d>
      </el-tab-pane>
      <el-tab-pane label="盘库账单" name="three" v-if="btnFlg[2]">
        <pan-ku-z-d ref="pkBill" v-if="activeName=='three'"></pan-ku-z-d>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import jianCaiZD from './jianCaiZD.vue'
import juanBanZD from './juanBanZD.vue'
import panKuZD from './panKuZD.vue'
import {
  getBtn
} from '@/utils/getButton'

export default {
  components: {
    jianCaiZD,
    juanBanZD,
    panKuZD
  },
  data () {
    return {
      activeName: 'first',
      btnFlg: [],
      btnIdArr: [
        '003M320200',
        '003M320300',
        '003M320400',
        '003M320500',
        '003M320600',
        '003M320700',
        '003M320800',
        '003M320900',
        '003M320A00',
        '003M320B00',
        '003M320C00',
        '003M320D00',
        '003M320E00',
        '003M320F00',
        '003M320G00',
        '003M320H00',
        '003M320I00',
        '003M320J00',
        '003M320K00',
        '003M320L00',
        '003M320M00',
        '003M320N00',
        '003M320O00',
        '003M320P00',
        '003M320Q00',
        '003M320R00',
        '003M320S00',
        '003M320T00',
        '003M320U00',
        '003M320V00'
      ]
    }
  },
  methods: {
    handleClicktab (tab, event) {
      console.log(tab, event)
      if (tab.name == 'first') {
        this.$refs.jbBill.chongzhi()
      } else if (tab.name == 'second') {
        this.$refs.jcBill.chongzhi()
      } else {
        this.$refs.pkBill.chongzhi()
      }
    }

  },
  created () {

  },
  mounted () {
    this.btnFlg = getBtn(this.btnIdArr, '/billManagement')
    this.activeName = this.btnFlg[3] ? 'first' : 'second'
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  /deep/.el-table th.star div::before {
    content: '*' !important;
    color: red !important;
  }
    /deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
